import { TextInput } from '@dreryk/react-components';

import { patientEntitlementsTranslationKeys } from '../../translations';
import { PatientEntitlementCreateFormController } from '../create/PatientEntitlementCreateForm.types';

type ConfirmingDocumentNumberTextInputProps = Pick<PatientEntitlementCreateFormController, 'register'>;

const CONFIRMING_DOCUMENT_NUMBER_MAX_LENGTH = 20;

export const ConfirmingDocumentNumberTextInput = (props: ConfirmingDocumentNumberTextInputProps): JSX.Element => {
   const controller = props.register('confirmingDocumentNumber', {
      required: true,
      maxLength: CONFIRMING_DOCUMENT_NUMBER_MAX_LENGTH,
   });

   return (
      <TextInput
         label={patientEntitlementsTranslationKeys.confirmingDocumentNumber}
         placeholder={patientEntitlementsTranslationKeys.insertConfirmingDocumentNumber}
         controller={controller}
         testId={'confirmingDocumentNumber'}
      />
   );
};
